import React from 'react'
import PropTypes from 'prop-types'
import { fileStatus } from '../../../../media'
import { CloudUpload, ErrorIcon, TrashIcon } from 'images'
import InfoBox from 'components/Shared/InfoBox'
import { filesize } from 'filesize'
import { useAcceptedFileService } from './AcceptedFile.service'
import { UploadButtons } from './elements/UploadButtons'

const fileInfo = (file) => {
  return (
    <div>
      <div>{file.name || file.filename}</div>
  
      <div>{filesize(file.size || 0)}</div>
    </div>
  )
}

const AcceptedFile = ({ file, uploadingFile, readonly, canRemove, onRemove, onRemoveFromGroup, onRetry, onClick, handleFileSelect, feedFile, reelFile, setNoDelete }) => {
  const { feedButtonFilled, reelButtonFilled } = useAcceptedFileService({ file, feedFile, reelFile })
  const displayFile = () => {
    switch (file.status) {
      case fileStatus.new:
      case fileStatus.uploading: {
        // Display file is uploading (first upload) - show preview and progress
        const isFeed = file.placement_type === 'feed'
        const isReel = file.placement_type === 'reel'

        return (
          <>
            {file.preview ? (
              <div className="accepted-file__thumb">
                {file.type && file.type.startsWith('video') ? (
                  <video controls={false} src={file.preview} title={file.name}></video>
                ) : (
                  <img src={file.preview} alt={file.name} />
                )}
              </div>
            ) : (
              <CloudUpload width={30} />
            )}

            <UploadButtons 
              feedButtonFilled={feedButtonFilled} 
              reelButtonFilled={reelButtonFilled} 
              handleFileSelect={handleFileSelect}
              fileId={file.id}
              feedFileId={feedFile?.id}
              reelFileId={reelFile?.id}
              showFeedProgress={isFeed}
              showReelProgress={isReel}
              progress={file.progress || 0}
              canRemove={canRemove}
              onRemoveFromGroup={onRemoveFromGroup}
              setNoDelete={setNoDelete}
            />
          </>
        )
      }
      case fileStatus.success: {
        // Determine if we should show progress from uploadingFile
        const showFeedProgress = uploadingFile && uploadingFile.placement_type === 'feed'
        const showReelProgress = uploadingFile && uploadingFile.placement_type === 'reel'
        const progress = uploadingFile ? (uploadingFile.progress || 0) : 0
        
        return (
          <>
            <InfoBox body={fileInfo(file)} withAnchor={false} tooltipClassNames="topic-tooltip">
              <div className="accepted-file__thumb" onClick={() => onClick(file)}>
                {file.type && file.type.startsWith('video') ? (
                  <video controls={false} src={file.url} title={file.name}></video>
                ) : (
                  <img src={file.preview || file.url} alt={file.name} />
                )}
              </div>
            </InfoBox>
  
            {!readonly && canRemove && (
              <span className="icons_remove-icon">
                <TrashIcon onClick={onRemove} width={14} />
              </span>
            )}
  
            <UploadButtons 
              feedButtonFilled={feedButtonFilled} 
              reelButtonFilled={reelButtonFilled} 
              handleFileSelect={handleFileSelect}
              fileId={file.id}
              feedFileId={feedFile?.id}
              reelFileId={reelFile?.id}
              showFeedProgress={showFeedProgress}
              showReelProgress={showReelProgress}
              progress={progress}
              readonly={readonly}
              canRemove={canRemove}
              onRemoveFromGroup={onRemoveFromGroup}
              setNoDelete={setNoDelete}
            />
          </>
        )
      }
      case fileStatus.invalid:
      case fileStatus.uploadFailed:
        return (
          <>
            <span className="icons_error-icon">
              <ErrorIcon
                title={file.error}
                width={24}
                onClick={() => file.status === fileStatus.uploadFailed && onRetry(file)}
              />
            </span>
            {!readonly && canRemove && (
              <span className="icons_remove-icon">
                <TrashIcon onClick={onRemove} width={14} />
              </span>
            )}
          </>
        )
      default:
        return null
    }
  }

  // return
  return (
    <div key={file.key} className="accepted-file accepted-file__itemBox">
      {displayFile()}
    </div>
  
  )
}

export default AcceptedFile
  
AcceptedFile.propTypes = {
  file: PropTypes.object,
  uploadingFile: PropTypes.object,
  onRemove: PropTypes.func,
  onRemoveFromGroup: PropTypes.func,
  onReplaceStarted: PropTypes.func,
  onRetry: PropTypes.func,
  readonly: PropTypes.bool,
  canRemove: PropTypes.bool,
  onClick: PropTypes.func,
  setNoDelete: PropTypes.func,
}